// extracted by mini-css-extract-plugin
export default {"wrapper":"PresetManager_wrapper__wf7TK","flex_h_center":"PresetManager_flex_h_center__iiHwg"};